import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2e6a7e02")

_pushScopeId("data-v-2e6a7e02")
const _hoisted_1 = {
  key: 0,
  class: "p-d-flex p-flex-column"
}
const _hoisted_2 = { class: "p-m-auto" }
const _hoisted_3 = {
  width: "29",
  height: "37",
  viewBox: "0 0 29 37",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_4 = { class: "p-mt-3" }
const _hoisted_5 = { class: "box-text" }
const _hoisted_6 = {
  key: 1,
  class: "p-d-flex p-flex-column"
}
const _hoisted_7 = { class: "p-m-auto" }
const _hoisted_8 = {
  width: "42",
  height: "36",
  viewBox: "0 0 42 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_9 = { class: "p-mt-3" }
const _hoisted_10 = { class: "box-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    id: "tecbanCardShadow",
    class: "p-m-4 box",
    style: _ctx.pstyle
  }, [
    _createVNode("a", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToView(_ctx.viewName)))
    }, [
      (_ctx.imgName == 'meus-compartilhamentos')
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              (_openBlock(), _createBlock("svg", _hoisted_3, [
                _createVNode("path", {
                  fill: _ctx.fillSVG1,
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M5 36.6667H1.66667H0V33.3333H1.66667V18.3333V5V0H5L5 1.66667H28.5412L23.5433 11.6665L28.5434 21.6667H5L5 33.3333H6.66667V36.6667H5ZM5 18.3333V5H23.1488L19.8167 11.6668L23.1499 18.3333H5Z"
                }, null, 8, ["fill"])
              ]))
            ]),
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, _toDisplayString(_ctx.cardLabel), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.imgName == 'meus-consentimentos')
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              (_openBlock(), _createBlock("svg", _hoisted_8, [
                _createVNode("path", {
                  fill: _ctx.fillSVG2,
                  d: "M8.16659 9.49992H12.7499V14.0833H8.16659V9.49992Z"
                }, null, 8, ["fill"]),
                _createVNode("path", {
                  fill: _ctx.fillSVG2,
                  d: "M8.16659 21.4166V18.6666H10.9166V21.4166H8.16659Z"
                }, null, 8, ["fill"]),
                _createVNode("path", {
                  fill: _ctx.fillSVG2,
                  d: "M18.2499 21.4166V18.6666H13.6666V21.4166H18.2499Z"
                }, null, 8, ["fill"]),
                _createVNode("path", {
                  fill: _ctx.fillSVG2,
                  d: "M27.65 29.1417C28.1852 29.4141 28.83 29.5945 29.5872 29.6802L29.686 29.6913V30.7838C29.686 30.8643 29.712 30.9229 29.7595 30.9683C29.8227 31.0188 29.8893 31.0416 29.963 31.0416H31.2557C31.3437 31.0416 31.4074 31.0165 31.4566 30.9708C31.5058 30.925 31.5327 30.8657 31.5327 30.7838V29.6776L31.6306 29.6658C32.736 29.5324 33.6062 29.2004 34.2499 28.6763C34.889 28.156 35.2083 27.4895 35.2083 26.6682C35.2083 26.0835 35.0765 25.6121 34.8215 25.247C34.5659 24.8812 34.1644 24.5787 33.6076 24.3433C33.0489 24.0975 32.2896 23.8912 31.3289 23.7278L31.326 23.7273C30.7324 23.611 30.2699 23.4988 29.941 23.3902L29.9368 23.3888C29.6191 23.2705 29.3747 23.1384 29.2139 22.9888L29.211 22.9861C29.0547 22.8295 28.9785 22.6341 28.9785 22.4077C28.9785 22.0764 29.1192 21.8153 29.4023 21.6397C29.6776 21.4689 30.0613 21.3902 30.5393 21.3902C30.9589 21.3902 31.3178 21.4703 31.6096 21.6372C31.8996 21.7972 32.0931 21.9993 32.1689 22.2474C32.2205 22.3162 32.2718 22.3612 32.3211 22.388C32.3838 22.4166 32.4683 22.4336 32.5795 22.4336H34.6353C34.6993 22.4336 34.7472 22.4153 34.7865 22.38C34.8313 22.3303 34.8494 22.2831 34.85 22.2363C34.8299 21.8918 34.6979 21.5381 34.4473 21.1744C34.1985 20.8132 33.8327 20.4901 33.3454 20.2067L33.3431 20.2053C32.8704 19.9153 32.2992 19.7168 31.6266 19.6125L31.5327 19.598V18.466C31.5327 18.3841 31.5058 18.3248 31.4566 18.2791C31.4074 18.2333 31.3437 18.2083 31.2557 18.2083H29.963C29.8893 18.2083 29.8227 18.231 29.7595 18.2815C29.712 18.3269 29.686 18.3855 29.686 18.466V19.5722L29.5881 19.5841C28.5682 19.7074 27.7726 20.0382 27.1916 20.5694C26.6112 21.0909 26.3219 21.7214 26.3219 22.4657C26.3219 23.3101 26.6179 23.9496 27.2002 24.3996C27.7922 24.8571 28.7057 25.2051 29.9537 25.4354C30.6297 25.5708 31.1451 25.6929 31.4937 25.801C31.8415 25.9089 32.108 26.0352 32.281 26.1849C32.4716 26.3406 32.5672 26.5432 32.5672 26.7842C32.5672 27.1257 32.3856 27.394 32.0455 27.5838C31.7088 27.7718 31.2334 27.8596 30.6327 27.8596C30.1125 27.8596 29.6856 27.7759 29.3611 27.5989C29.0595 27.4285 28.8318 27.2103 28.6859 26.9452C28.6128 26.8704 28.5439 26.8204 28.4799 26.7907L28.4721 26.787L28.4649 26.7822C28.4175 26.7507 28.3444 26.7293 28.2343 26.7293H26.2719C26.2114 26.7293 26.1561 26.7499 26.1021 26.8001C26.0601 26.8392 26.0421 26.8801 26.0416 26.927C26.0619 27.3609 26.2007 27.7723 26.46 28.1625C26.7284 28.5413 27.1233 28.8684 27.65 29.1417Z"
                }, null, 8, ["fill"]),
                _createVNode("path", {
                  fill: _ctx.fillSVG2,
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M37.3749 0.333252H3.70825C2.16056 0.333252 0.833252 1.72759 0.833252 3.54159V25.5416C0.833252 27.3556 2.16056 28.7499 3.70825 28.7499H21.0207C22.6206 32.4699 26.3185 35.0748 30.6249 35.0748C36.3963 35.0748 41.0749 30.3962 41.0749 24.6248C41.0749 23.1785 40.7811 21.8009 40.2499 20.5483V3.54159C40.2499 1.72759 38.9226 0.333252 37.3749 0.333252ZM20.1749 24.6248C20.1749 25.0909 20.2054 25.5499 20.2646 25.9999H3.58325V3.08325H37.4999V16.7546C35.6624 15.1481 33.2573 14.1748 30.6249 14.1748C24.8535 14.1748 20.1749 18.8534 20.1749 24.6248ZM22.7416 24.6248C22.7416 20.2709 26.2711 16.7415 30.6249 16.7415C34.9788 16.7415 38.5082 20.2709 38.5082 24.6248C38.5082 28.9786 34.9788 32.5081 30.6249 32.5081C26.2711 32.5081 22.7416 28.9786 22.7416 24.6248Z"
                }, null, 8, ["fill"])
              ]))
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.cardLabel), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 4))
})